"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LaunchTaskLabel = exports.LaunchTaskContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LaunchTaskContent = styled_components_1.default.span `
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  opacity: ${({ $disabled }) => ($disabled ? 0.5 : 1)};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
`;
exports.LaunchTaskLabel = styled_components_1.default.span `
  display: inline-flex;
  align-items: center;
`;
